
import { USER_AUDIT_EVENT_METADATA } from './user-audit-event.metadata';
import { UserAuditEventBase } from './user-audit-event.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface UserAuditEvent extends UserAuditEventBase {
}

export interface UserAuditEventTransient { }

export class UserAuditEvent extends CrudEntity<UserAuditEvent, any, UserAuditEventTransient> implements UserAuditEventTransient {
  constructor(source?: Partial<UserAuditEvent>, options?: CrudEntityConstructionOptions<UserAuditEvent, any, UserAuditEventTransient>) {
    super(USER_AUDIT_EVENT_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





